import Vue from 'vue'
import Vuex from 'vuex'

import axios from 'axios'

const timeStamp = Math.floor( Date.now() /1000)

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    langfile: "lang.hu.json",
    needPD: true,
    menu: {
      headermenu: [],
      mainmenu: [],
      footer1menu: [],
      footer2menu: []
    },
    lang:{
      languages: [], 
      defLang:{
        id: '1',
        name: 'hu'
      },
      selectedLang: { 
        id: null,
        name: null
      }      
    },      
    products: {
      category: []      
    },
    recipes:{
      category: []      
    },
    information_to_category: [],
    news:{
      category: []
    },
    careerSelectedPos: '',
    searchedText: ''
  },  
  getters:{
    getLangFile: state => {
      return state.langfile
    },
    getSelectedLang: state => {        
      return state.lang.selectedLang;      
    },   
    getDefaultLang: state => {        
      return state.lang.defLang;      
    }, 
    getLanguages: state => {
      return state.lang.languages
    },
    getLang: state => {
      return state.lang
    },
    getMenuHeaderMenu: state => {
      return state.menu.headermenu
    },
    getMenuMainMenu: state => {
      return state.menu.mainmenu
    },
    getMenuFooter1Menu: state => {
      return state.menu.footer1menu
    },
    getMenuFooter2Menu: state => {
      return state.menu.footer2menu
    },
    getProducstCategory: state => {
      return state.products.category
    }, 
    getRecipesCategory: state => {
      return state.recipes.category
    },
    getInformationToCategory: state => {
      return state.information_to_category
    },
    getNewsCategory: state => {
      return state.news.category
    },
    getSelectedCareerPos: state => {
      return state.careerSelectedPos
    },
    getSearchedText: state => {
      return state.searchedText
    }
  },
  mutations: {
    SET_WEBSITE_LANGFILE(state, response){
      state.langfile = response
    },
    SET_MENU_HEADERMENU (state, response) {
      state.menu.headermenu = response;
    },
    SET_MENU_MAINMENU (state, response) {
      state.menu.mainmenu = response;
    },
    SET_MENU_FOOTER1MENU (state, response) {
      state.menu.footer1menu = response;
    },
    SET_MENU_FOOTER2MENU (state, response) {
      state.menu.footer2menu = response;
    },
    SET_LANGUAGES (state, response) {
      state.lang.languages = response;
    },
    SELECT_LANG (state, lang){
      state.lang.selectedLang = lang;
    },   
    SET_PRODUCTS_CATEGORY(state, response){
      state.products.category = response
    },
    SET_PRODUCTS_FEATURED_PRODUCTS (state, response) {
      state.products.featuredProducts = response
    },
    SET_RECIPES_CATEGORY (state, response){
      state.recipes.category = response
    },
    SET_INFORMATION_TO_CATEGORY(state, response){
      state.information_to_category = response
    },
    SET_NEWS_CATEGORY(state, response){
      state.news.category = response
    },
    SET_CAREER_POSITION(state, posId){
      state.careerSelectedPos = posId
    },
    SET_SEARCHED_TEXT(state,text){
      state.searchedText = text
    }
  },
  actions: {
    setWebsiteLangFile({ commit }) {
      let currentLang = {}
      if ( this.state.lang.selectedLang.id === null ) {
        currentLang = this.state.lang.defLang.name
      } else {
        currentLang = this.state.lang.selectedLang.name
      }
      // return new Promise((resolve) => {          
          axios.get(process.env.VUE_APP_BASE_URL + 'lang.'+ currentLang.toLowerCase() + '.json?' + timeStamp)
          .then(response => {
            commit("SET_WEBSITE_LANGFILE", response.data)                        
            // resolve()          
          })
          .catch((err) => console.log(err));
        // })
    },
    setMenu_headerMenu({ commit }) {        
      var _this = this;                                   
      axios.get(process.env.VUE_APP_BIFROST_API_URL + '/helper/menu/1',{
        params:{
          "language_id": this.state.lang.selectedLang.id          
        }
      }).then(response => {
        if (response.data.status === true){   
          var menu = [];
              if (_this.state.needPD)
              {
                for (var i = 0; i< response.data.menu.length; i++){
                  if (response.data.menu[i].published_date <=  new Date().toISOString().slice(0, 19).replace('T', ' '))
                  {
                    if (response.data.menu[i].children)
                    {
                      var children = [];
                      for (var j = 0; j < response.data.menu[i].children.length ; j++)
                      {
                        if (response.data.menu[i].children[j].published_date <=  new Date().toISOString().slice(0, 19).replace('T', ' '))
                        {
                          children.push(response.data.menu[i].children[j]);
                        }
                      }
                      response.data.menu[i].children = children;
                      menu.push(response.data.menu[i]);
                    }
                    else
                      menu.push(response.data.menu[i])
                  }
                }
              }       
              else
                menu = response.data.menu;
          commit("SET_MENU_HEADERMENU", menu);       
        } else {
          commit("SET_MENU_HEADERMENU", []);
        }
      }).catch((err) => {
        console.log(err)
      });     
    },
    setMenu_mainMenu({ commit }) {              
      var _this = this;                      
        axios.get(process.env.VUE_APP_BIFROST_API_URL + '/helper/menu/2',{
          params:{
            "language_id": this.state.lang.selectedLang.id            
          }
        }).then(response => {
          if (response.data.status === true){
            var menu = [];
              if (_this.state.needPD)
              {
                for (var i = 0; i< response.data.menu.length; i++){
                  if (response.data.menu[i].published_date <=  new Date().toISOString().slice(0, 19).replace('T', ' '))
                  {
                    if (response.data.menu[i].children)
                    {
                      var children = [];
                      for (var j = 0; j < response.data.menu[i].children.length ; j++)
                      {
                        if (response.data.menu[i].children[j].published_date <=  new Date().toISOString().slice(0, 19).replace('T', ' '))
                        {
                          children.push(response.data.menu[i].children[j]);
                        }
                      }
                      response.data.menu[i].children = children;
                      menu.push(response.data.menu[i]);
                    }
                    else
                      menu.push(response.data.menu[i])
                  }
                }
              }
              else
                menu = response.data.menu;
            commit("SET_MENU_MAINMENU", menu);          
          } else {
            commit("SET_MENU_MAINMENU", []);
          }          
        }).catch((err) => {
          console.log(err)
        });       
    },
    setMenu_footer1Menu({ commit }) {   
        
      var _this = this;                                   
        axios.get(process.env.VUE_APP_BIFROST_API_URL + '/helper/menu/3',{
          params:{
            "language_id": this.state.lang.selectedLang.id          
          }
        }).then(response => {
            if (response.data.status === true){
              var menu = [];
              if (_this.state.needPD)
              {
                for (var i = 0; i< response.data.menu.length; i++){
                  if (response.data.menu[i].published_date <=  new Date().toISOString().slice(0, 19).replace('T', ' '))
                  {
                    if (response.data.menu[i].children)
                    {
                      var children = [];
                      for (var j = 0; j < response.data.menu[i].children.length ; j++)
                      {
                        if (response.data.menu[i].children[j].published_date <=  new Date().toISOString().slice(0, 19).replace('T', ' '))
                        {
                          children.push(response.data.menu[i].children[j]);
                        }
                      }
                      response.data.menu[i].children = children;
                      menu.push(response.data.menu[i]);
                    }
                    else
                      menu.push(response.data.menu[i])
                  }
                }
              }
              else
                menu = response.data.menu;
              commit("SET_MENU_FOOTER1MENU", menu);           
            } else {
              commit("SET_MENU_FOOTER1MENU", []);
            }            
        }).catch((err) => {
          console.log(err)
        });       
    },
    setMenu_footer2Menu({ commit }) {     
      var _this = this;                                          
        axios.get(process.env.VUE_APP_BIFROST_API_URL + '/helper/menu/4',{
          params:{
            "language_id": this.state.lang.selectedLang.id          
          }
        }).then(response => {
            if (response.data.status === true){
              var menu = [];
              if (_this.state.needPD)
              {
                for (var i = 0; i< response.data.menu.length; i++){
                  if (response.data.menu[i].published_date <=  new Date().toISOString().slice(0, 19).replace('T', ' '))
                  {
                    if (response.data.menu[i].children)
                    {
                      var children = [];
                      for (var j = 0; j < response.data.menu[i].children.length ; j++)
                      {
                        if (response.data.menu[i].children[j].published_date <=  new Date().toISOString().slice(0, 19).replace('T', ' '))
                        {
                          children.push(response.data.menu[i].children[j]);
                        }
                      }
                      response.data.menu[i].children = children;
                      menu.push(response.data.menu[i]);
                    }
                    else
                      menu.push(response.data.menu[i])
                  }
                }
              }
              else
                menu = response.data.menu;
              commit("SET_MENU_FOOTER2MENU", menu);            
            } else {
              commit("SET_MENU_FOOTER2MENU", []);
            }            
        }).catch((err) => {
          console.log(err)
        });       
    },
    setLanguages( {commit}){               
        axios.get(process.env.VUE_APP_BIFROST_API_URL + '/language', 
          {
            params:{
              "select": ["name", "id"]
            }            
          }
        ).then(response => {
            if (response.data.status === true){
              commit("SET_LANGUAGES", response.data.language);                
            } else {
              commit("SET_LANGUAGES", []);  
            }
        }).catch((err) => {
          console.log(err)
        });             
    },
    setLang( {commit}, payload) {
      commit("SELECT_LANG", payload.lang);       
      if (payload.fgv){             
        payload.fgv()
      }
    },
    setProducts_category({ commit }) {       
     // var _this = this;                   
      //   return new Promise((resolve) => {          
        axios.get(process.env.VUE_APP_BIFROST_API_URL + '/helper/category/1',{
          params:{
            "language_id": this.state.lang.selectedLang.id                   
          }
        }).then(response => {
           /* var cat = [];
            if (_this.state.needPD)
            {
              for (var i = 0; i< response.data.category.length; i++){
                if (response.data.category[i].published_date <=  new Date().toISOString().slice(0, 19).replace('T', ' '))
                {
                  cat.push(response.data.category[i])
                }
              }
            }*/
            commit("SET_PRODUCTS_CATEGORY", response.data.category);
            // console.log("store adat", this.state.products.category)            
            //resolve()
          })
          .catch((err) => {
            console.log(err)
          }); 
      //   })
    },   
    setRecipes_category({commit}){
      // var _this = this;                   
      //   return new Promise((resolve) => {          
       // var _this = this;
        axios.get(process.env.VUE_APP_BIFROST_API_URL + '/helper/category/2',{
          params:{
            "language_id": this.state.lang.selectedLang.id                     
          }
        }).then(response => {
         
            commit("SET_RECIPES_CATEGORY",response.data.category);                       
            // console.log('Recept kategóriák: ', response.data.category);
            //resolve()
          })
          .catch((err) => {
            console.log(err)
          }); 
      //   })
    },
    set_Information_to_category({commit}){
      axios.get(process.env.VUE_APP_BIFROST_API_URL + '/information_to_category?relations=1'
      ).then(response => { 
        if (response.data.status === true){
          commit("SET_INFORMATION_TO_CATEGORY", response.data.information_to_category);  
        } else {
          commit("SET_INFORMATION_TO_CATEGORY", []);  
        }                                                                         
      })
      .catch((err) => {
          console.log(err)
      }); 
    },
    setNews_category({commit}){    
     // var _this = this;                          
        axios.get(process.env.VUE_APP_BIFROST_API_URL + '/helper/category/3',{
          params:{
            "language_id": this.state.lang.selectedLang.id                     
          }
        }).then(response => {
            // console.log(response.data)
            /*var cat = [];
            if (_this.state.needPD)
            {
              for (var i = 0; i< response.data.category.length; i++){
                if (response.data.category[i].published_date <=  new Date().toISOString().slice(0, 19).replace('T', ' '))
                {
                  cat.push(response.data.category[i])
                }
              }
            }*/
            if(response.data.status === true){
              commit("SET_NEWS_CATEGORY", response.data.category);              
            } else {
              commit("SET_NEWS_CATEGORY", []);              
            }                      
        })
        .catch((err) => {
          console.log(err)
        });       
    },
    setCareerPosition( {commit}, posId){
      // console.log(posId)
      commit("SET_CAREER_POSITION", posId);    
    },
    setSearchedText( {commit}, text){      
      commit("SET_SEARCHED_TEXT", text);    
    },
  }
})
